import React from 'react';
import { fmtDateTime } from '../../utils/helpers';

// Desktop OTP — centred card.
export default function OTPDesktop({ vm }) {
  const { mobile, boundModel, boundDate, otp, setOtp, busy, err, sent, reused, resend, verify, backToLogin } = vm;
  return (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-pad" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--brand)' }}>Verify OTP</div>
          <div className="muted" style={{ marginBottom: 10, fontSize: 13 }}>
            This account is signed in on another device
            {boundModel ? <> (<strong>{boundModel}</strong>{boundDate ? `, since ${fmtDateTime(boundDate)}` : ''})</> : null}.
            Verify the OTP to move it to <strong>this</strong> device — the other device will be signed out.
          </div>
          <div className="muted" style={{ marginBottom: 14, fontSize: 13 }}>
            {!sent ? 'Sending OTP…' : reused
              ? `Use the OTP already sent to WhatsApp ${mobile} at ${fmtDateTime(reused)} — it stays valid for 1 hour, so no new code was sent.`
              : `OTP sent to WhatsApp ${mobile} (valid for 1 hour)`}
            {sent && <> · <button type="button" className="linklike" onClick={resend}>Resend</button></>}
          </div>
          <form onSubmit={verify} style={{ textAlign: 'left' }}>
            <label className="field">4-digit OTP
              <input type="tel" maxLength={4} value={otp} onChange={(e) => setOtp(e.target.value)} />
            </label>
            {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
            <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
              {busy ? 'Verifying…' : 'Verify & Continue'}
            </button>
          </form>
          <div className="muted" style={{ fontSize: 12, marginTop: 12 }}>No WhatsApp on this number? Ask a Super Admin to reset your device, then sign in again.</div>
          <button className="btn light sm" style={{ marginTop: 10 }} onClick={backToLogin}>Back to login</button>
        </div>
      </div>
    </div>
  );
}
